module.exports = __webpack_public_path__ + "static/the-world-is-flat-further-updated-and-expanded-release-30-19f28837d06698396d0212a7928b4a7c.jpg";